// extracted by mini-css-extract-plugin
export default {"subtitle":"create-transaction-message_subtitle__m6QnJ"};